export default function useCurrency() {
	return {
		currency: App.state.rootStore.userAuthStore.currency,
	};
}
